import { createSelector } from "reselect";
import { AppState } from "src/features";

export const getJoinGroupTabState = (state: AppState) => state.groupTabs.joinTab;

export const getJoinGroupTabError = createSelector(getJoinGroupTabState, ({ error }) => error);

export const getJoinGroupTabCode = createSelector(getJoinGroupTabState, ({ joinCode }) => joinCode);
